<h2 mat-dialog-title class="dialog-title">
  <mat-icon class="title-icon">place</mat-icon>
  Location details — {{ data.programName }}
</h2>

<mat-dialog-content>
  <table mat-table [dataSource]="data.rows" class="location-table">

    <ng-container matColumnDef="campaignTitle">
      <th mat-header-cell *matHeaderCellDef>Campaign</th>
      <td mat-cell *matCellDef="let row" [class.cell--diff]="row.hasDiff">
        {{ row.campaignTitle }}
      </td>
    </ng-container>

    <ng-container matColumnDef="locations">
      <th mat-header-cell *matHeaderCellDef>Locations</th>
      <td mat-cell *matCellDef="let row" [class.cell--diff]="row.hasDiff">
        @if (row.hasDiff) {
          <mat-icon class="diff-icon">warning</mat-icon>
        }
        {{ row.locations }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
